export const Statuses = {
    IN_WORK_STATUS: 'in_work',
    FOR_APPROVAL_STATUS: 'for_approval',
    REJECTED_STATUS: 'rejected',
    APPROVED_STATUS: 'approved',
    DELETED_STATUS: 'deleted',
    STATUS_SIGNED: 'signed',
}
export const STATUSES_RU = {
    IN_WORK_STATUS: 'В работе',
    FOR_APPROVAL_STATUS: 'На утверждении',
    REJECTED_STATUS: 'Отклонен',
    APPROVED_STATUS: 'Утвержден',
    DELETED_STATUS: 'Удален',
    STATUS_SIGNED: 'Подписан Акт',
}

export const STATUSES_RU_ABBREVIATED = {
    IN_WORK_STATUS: 'В/Р',
    FOR_APPROVAL_STATUS: 'На/утв',
    REJECTED_STATUS: 'Откл',
    APPROVED_STATUS: 'Утв',
    DELETED_STATUS: 'Уд',
    STATUS_SIGNED: 'Подп',
}



export const StatusesOptions = [
    {value: Statuses.IN_WORK_STATUS, label: STATUSES_RU.IN_WORK_STATUS},
    {value: Statuses.FOR_APPROVAL_STATUS, label: STATUSES_RU.FOR_APPROVAL_STATUS},
    {value: Statuses.REJECTED_STATUS, label: STATUSES_RU.REJECTED_STATUS},
    {value: Statuses.APPROVED_STATUS, label: STATUSES_RU.APPROVED_STATUS},
    {value: Statuses.DELETED_STATUS, label: STATUSES_RU.DELETED_STATUS},
    {value: Statuses.STATUS_SIGNED, label: STATUSES_RU.STATUS_SIGNED},
]